import React from 'react';
import LazyHero from 'react-lazy-hero';
import ProgressiveImage from 'react-progressive-image';
import blurTitlePoster from '../../assets/blurTitlePoster.jpg';
import './HeroTitle.scss';

const HeroTitle = ({
  poster,
  backTo,
  cardImg,
  title,
  rating,
  release_date,
  genres
}) => {
  return (
    <div className="title">
      <LazyHero
        className="title-container-hero"
        imageSrc={poster}
        minHeight="100vh"
        color="#141E30"
        opacity={0.5}
        isCentered={false}
        parallaxOffset={100}
      />
      <div className="title-container">
        <div className="title-container-controls">
          <span onClick={backTo}>
            <svg
              className="title-container-controls__back"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512">
              <path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z" />
            </svg>
          </span>
          <p />
        </div>
        <div className="title-container-description">
          <ProgressiveImage src={cardImg} placeholder={blurTitlePoster}>
            {(src, loading) => (
              <img
                style={{
                  opacity: loading ? 0.5 : 0.9,
                  filter: loading ? 'blur(5px)' : '',
                  width: loading ? 'auto' : 'auto',
                  borderRadius: loading ? '4rem' : '4rem',
                  padding: loading ? '2rem' : '2rem',
                  transition: 'opacity 1s ease'
                }}
                src={src}
                alt="poster"
              />
            )}
          </ProgressiveImage>
          <div className="title-container-description-info">
            <h1 className="title-container-description-info__title">{title}</h1>
            <p className="title-container-description-info__rating">
              Rating: {rating}
            </p>
            <p className="title-container-description-info__release">
              {release_date}
            </p>
            <p className="title-container-description-info__genres">{genres}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroTitle;
